import es from './es';
import en from './en';

export { es, en };

export default { es, en };
